export class LoadAllLicenses {
  static readonly type = '[Licenses] Load All';
}
